export default defineNuxtRouteMiddleware((to, from) => {
  // skip middleware on server
  if (import.meta.server) return

  if (from.query.dbcembedded === '1' && !to.query.dbcembedded) {
    const newTo = { ...to }
    newTo.query.dbcembedded = '1'
    return newTo
  }

  if (from.query.dbcembedded === '2' && !to.query.dbcembedded) {
    const newTo = { ...to }
    newTo.query.dbcembedded = '2'
    return newTo
  }

  return
})
